import HTTP from '@/http-common.js'
import EventBus from '@/bus.js'

const DisableItem = {
  methods: {
    disabler(type = 'resource') {
      let status = this.item.status
      if (this.item.status === 'disabled' || this.item.status === 'pending') {
        status = 'published'
        if (type === 'org') status = 'active'
      } else {
        status = 'disabled'
      }

      let requestURL = `${type}/update/${this.item.id}`
      let requestBody = { status }

      if (type === 'org') requestURL = `${type}/${this.item.id}/update/`
      if (this.item.websites) requestBody.api_keys = this.item.websites.map((website) => website.api_key)

      HTTP.post(requestURL, requestBody)

      const item = JSON.parse(JSON.stringify(this.item))
      item.status = this.status = status

      if (type === 'tag') {
        this.$store.dispatch('updateTag', { item: item, type: 'disable' })
        EventBus.$emit('clearSelected')
      } else if (type === 'org') {
        this.$store.dispatch('updateOrg', { item: item, type: 'disable' })
        EventBus.$emit('clearSelected')
      } else {
        this.item.status = status
        EventBus.$emit('itemDisable', JSON.stringify(this.item))
      }
    },
    disable(type = 'resource') {
      let label = type
      if (type === 'org') label = 'organisation'
      if (confirm(`Are you sure you want to ${this.disableLabel.toLowerCase()} this ${label}?`)) {
        this.disabler(type)
      }
    },
  },
  computed: {
    disableLabel() {
      if (this.status === 'disabled' || this.status === 'pending') {
        return this.$store.getters.getStringTranslation('enable')
      } else {
        return this.$store.getters.getStringTranslation('disable')
      }
    },
  },
}

export default DisableItem
